<template>
  <AnimatedBackground>
    <PeopleSection />
  </AnimatedBackground>
</template>

<script>
import PeopleSection from '../components/PeopleSection.vue';
import AnimatedBackground from '../components/AnimatedBackground.vue';

export default {
  name: 'PeoplePage',
  components: {
    PeopleSection,
    AnimatedBackground
  }
}
</script>

<style scoped>
.people-page {
  min-height: 100vh;
  width: 100%;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
}
</style>
